import React from "react";

import { ImageData } from "@/service/Model";

import { Flex, Image, Label, TextWrap } from "./styles";

export type ImageCopyrightProps = {
  imageData: ImageData;
  sourceLabel: string;
};

const isDaliUrl = (url: string): boolean => {
  return url.indexOf("://production.la.welt.de/dali/") > -1;
};

const ImageCopyright: React.FC<ImageCopyrightProps> = (
  props: ImageCopyrightProps
): React.JSX.Element => {
  const {
    sourceLabel,
    imageData: { url, source, copyright },
  } = props;

  return (
    <Flex>
      <Image imageUrl={url} isDaliUrl={isDaliUrl(url)} />
      <TextWrap>
        {source && (
          <div>
            <Label>{`${sourceLabel}: `}</Label>
            {source}
          </div>
        )}
        <div>{copyright}</div>
      </TextWrap>
    </Flex>
  );
};

export default ImageCopyright;
